import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: { label: string; to: string };
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  action,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";

  return (
    <div
      className={`flex flex-col gap-4 ${
        isCenter
          ? "items-center text-center"
          : "md:flex-row md:items-end md:justify-between"
      }`}
    >
      <div className={isCenter ? "max-w-2xl" : "max-w-2xl"}>
        {eyebrow ? (
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-secondary-700">
            <span className="h-1 w-1 rounded-full bg-accent-500" />
            {eyebrow}
          </span>
        ) : null}
        <h2 className="font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {description ? (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {description}
          </p>
        ) : null}
      </div>

      {action ? (
        <Link
          to={action.to}
          className="group inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-semibold text-foreground-800 transition-colors duration-200 hover:border-primary-300 hover:bg-primary-50 hover:text-primary-800"
        >
          {action.label}
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line text-base transition-transform duration-200 group-hover:translate-x-0.5" />
          </span>
        </Link>
      ) : null}
    </div>
  );
}